import { takeLatest } from 'redux-saga/effects';
import {
  formSubmitRequest,
  userLoginRequest,
  generateLinkRequest,
  getCustomerFormDataRequest,
  getBusinessRegistrationNumberRequest,
  getPreferdPartnerDataRequest,
  getApplicantEmailValidateRequest,
  getTenantAccountTypesRequest,
} from '../reducer/homeDataSlice';

import {
  handleFormSubmit,
  handleUserLogin,
  handleGenerateLink,
  handleGetCustomerFormData,
  handleGetBusinessRegistrationNumber,
  handleGetPreferedPartnerData,
  handleGetValidApplicantEmail,
  handleGetTenantAccountTypes,
} from './homeSaga';
import { get } from 'http';

export default function* homeSaga() {
  yield takeLatest(formSubmitRequest.type, handleFormSubmit);
  yield takeLatest(userLoginRequest.type, handleUserLogin);
  yield takeLatest(generateLinkRequest.type, handleGenerateLink);
  yield takeLatest(getCustomerFormDataRequest.type, handleGetCustomerFormData);

  //validated business reg number
  yield takeLatest(getBusinessRegistrationNumberRequest.type, handleGetBusinessRegistrationNumber);

  //get preferedpartner data
  yield takeLatest(getPreferdPartnerDataRequest.type, handleGetPreferedPartnerData);

  // validate applicant email
  yield takeLatest(getApplicantEmailValidateRequest.type, handleGetValidApplicantEmail);
//get tenant account types dropdown
  yield takeLatest(getTenantAccountTypesRequest.type, handleGetTenantAccountTypes);
}
